// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12KMm","right":"styles_right__2Zom3"};